<template>
  <section>
    <div>
      <div class="content" style="background-color: rgb(49, 48, 54)">
        <h3 style="color:white; margin-left:15px;"><b>Dashboard</b></h3>
        <br>
        <div class="row">
          <div class="col-md-3 cursor-p">
            <div class="card mb-3 removeline" tabindex="0">
              <div class="card-header fw-600 p-2">
                <div class="row">
                  <div class="col-md-3 iconBg mt-2" style="background-color: #5bad2b">
                    <i class="fa fa-users" aria-hidden="true"></i>
                  </div>
                  <div class="col-md-2 removeline">
                    <h4 style="color:rgb(96, 95, 95)">Organization</h4>
                    <h4><strong>50</strong></h4>
                  </div>
                  <!-- <div class="col-md-2 removeline mt-2"> <i class="uil uil-arrow-right fa-2x"></i></div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 cursor-p">
            <div class="card mb-3 removeline" tabindex="0">
              <div class="card-header fw-600 p-2">
                <div class="row">
                  <div class="col-md-3 iconBg mt-2" style="background-color: rgb(247, 187, 46)">
                    <i class="fa fa-user" aria-hidden="true"></i>
                  </div>
                  <div class="col-md-2 removeline">
                    <h4 style="color:rgb(96, 95, 95)">Interviewers</h4>
                    <h4><strong>400</strong></h4>
                  </div>
                  <!-- <div class="col-md-2 removeline mt-2"> <i class="uil uil-arrow-right fa-2x"></i></div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 cursor-p">
            <div class="card mb-3 removeline" tabindex="0">
              <div class="card-header fw-600 p-2">
                <div class="row">
                  <div class="col-md-3 iconBg mt-2" style="background-color: rgb(46, 123, 247)">
                    <i class="fa fa-user" aria-hidden="true"></i>
                  </div>
                  <div class="col-md-2 removeline">
                    <h4 style="color:rgb(96, 95, 95)">Candidates</h4>
                    <h4><strong>3090</strong></h4>
                  </div>
                  <!-- <div class="col-md-2 removeline mt-2"> <i class="uil uil-arrow-right fa-2x"></i></div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 cursor-p">
            <div class="card mb-3 removeline" tabindex="0">
              <div class="card-header fw-600 p-2">
                <div class="row">
                  <div class="col-md-3 iconBg mt-2" style="background-color: red">
                    <i class="fa fa-newspaper-o" aria-hidden="true"></i>
                  </div>
                  <div class="col-md-2 removeline">
                    <h4 style="color:rgb(96, 95, 95)">Posts</h4>
                    <h4><strong>200</strong></h4>
                  </div>
                  <!-- <div class="col-md-2 removeline mt-2"> <i class="uil uil-arrow-right fa-2x"></i></div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="row mb-2" style="margin-top:-55px">
          <div class="col-md-8 cursor-p">
            <div class="card mb-3 graphline" tabindex="0">
              <div class="cardHeader">
                <div><h5><b>Schedule Report</b></h5></div>
                <div class="dropdown">
                  <a class="dropdown-toggle" data-toggle="dropdown">
                    <span style="color: black; font-size: 12px; font-weight:bold;">{{filter}}
                      <i class="fa fa-caret-down ml-5" aria-hidden="true"></i>
                    </span>
                  </a>
                  <ul class="dropdown-menu logmenu" style="width: 210px;">
                    <li>
                      <a @click="filter='Weekly'">Weekly</a>
                    </li>
                    <li>
                      <a @click="filter='Monthly'">Monthly</a>
                    </li>
                    <li>
                      <a @click="filter='Yearly'">Yearly</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div style="width:500px; height: 300px; text-align:center; display:flex; align-items: center;">
                <canvas id="planetchart" width="400" height="250"></canvas>
              </div>
            </div>
          </div>
          <div class="col-md-4 cursor-p">
            <div class="card mb-3 graphline" tabindex="0">
              <div class="cardHeader">
                <div><h5><b>Schedule Report</b></h5></div>
                <div class="dropdown">
                  <a class="dropdown-toggle" data-toggle="dropdown">
                    <span style="color: black; font-size: 12px; font-weight:bold;">{{filter}}
                      <i class="fa fa-caret-down ml-5" aria-hidden="true"></i>
                    </span>
                  </a>
                  <ul class="dropdown-menu logmenu" style="width: 210px;">
                    <li>
                      <a @click="filter='Weekly'">Weekly</a>
                    </li>
                    <li>
                      <a @click="filter='Monthly'">Monthly</a>
                    </li>
                    <li>
                      <a @click="filter='Yearly'">Yearly</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Chart from 'chart.js'
import $ from 'jquery'

export default {
  data () {
    return {
      filter: 'Weekly'
    }
  },
  created () {
    this.getChart()
  },
  methods: {
    getChart () {
      if (window.myChart instanceof Chart) {
        console.log('enter ', window.myChart)
        window.myChart.destroy()
      }
      $('#planetchart').replaceWith($('<canvas id="planetchart" width="400" height="250"></canvas>'))
      var exampleChart = new Chart('planetchart', {
        type: 'line',
        data: {
          labels: ['Jan1', 'Jan2', 'Jan3', 'Jan4', 'Jan5', 'Jan6', 'Jan7'],
          datasets: [
            {
              label: 'This week',
              data: [12, 19, 10, 17, 6, 3, 7],
              backgroundColor: 'rgba(224, 248, 255, 0.4)',
              borderColor: '#5cddff',
              lineTension: 0,
              pointBackgroundColor: '#5cddff'
            },
            {
              label: 'Last week',
              data: [10, 25, 3, 25, 17, 4, 9],
              backgroundColor: 'rgba(241, 225, 197, 0.4)',
              borderColor: '#ffc764',
              lineTension: 0,
              pointBackgroundColor: '#ffc764'
            }
          ]
        },
        options: {
          scales: {
            xAxes: [
              {
                stacked: true,
                gridLines: { display: false }
              }
            ],
            yAxes: [
              {
                ticks: {
                  stepSize: 1
                  // callback: function(value, index, values) {
                  //   if (value % Math.round(values[0] / 6) == 0) {
                  //     return value;
                  //   } else if (value === 0) {
                  //     return value;
                  //   }
                  // }
                }
                // stacked: true
              }
            ]
          },
          maintainAspectRatio: false,
          legend: {
            labels: {
              boxWidth: 10
            },
            position: 'top'
          },
          animation: {
            duration: 2000,
            easing: 'easeInOutQuart'
          }
        }
      })
      console.log('exampleChart1', exampleChart)
    }
  }

}
</script>

<style scoped>
.removeline{
  background-color: white;
  border-radius: 5px;
  padding: 5px 10px 1px 10px;
}
.graphline {
  background-color: white;
  border-radius: 5px;
  padding: 15px;
  min-height: 350px;
}
.iconBg {
  height: 55px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 25px;
  color: white;
}
.cardHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgb(223, 221, 221);
}

</style>
